import { Suspense } from 'react';

import { useSuspenseQuery } from '@tanstack/react-query';

import { Chip, Skeleton } from '@mui/material';

import { useFieldContext } from '#form';

import { claimQueries } from '@repo/api/claim/claims';
import { CodeInput } from '@repo/ui/CodeInput';
import { LabelInput } from '@repo/ui/LabelInput';

export function CauseOfLossCodeInput() {
	const field = useFieldContext<number | null | undefined>();

	return (
		<Suspense
			fallback={
				<LabelInput label="Lloyd's Cause of Loss Code" fieldName={field.name}>
					<Skeleton />
				</LabelInput>
			}
		>
			<CauseOfLossCodeField />
		</Suspense>
	);
}

function CauseOfLossCodeField() {
	const field = useFieldContext<number | null | undefined>();

	const { data: causeOfLossCodes } = useSuspenseQuery(
		claimQueries.causeOfLossCodes(),
	);

	return (
		<CodeInput
			label="Lloyd's Cause of Loss Code"
			name={field.name}
			value={field.state.value}
			onChange={field.handleChange}
			errors={field.state.meta.errors}
			codes={[
				{
					category: '',
					items: causeOfLossCodes,
				},
			]}
			minInput={0}
			renderCode={(code) => <Chip size="small" label={<code>{code}</code>} />}
		/>
	);
}
